import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { checkForFormFieldErrors } from 'src/app/shared/helpers/form-errors';
import { MessageDisplayModel } from 'src/app/shared/message/messageDisplay.model';
import { MessageDisplayService } from 'src/app/shared/services/message-display.service';
import { MessagesService } from 'src/app/shared/services/messages.service';

@Component({
  selector: 'contact-us-form',
  templateUrl: './contact-us-form.component.html'
})
export class ContactUsFormComponent implements OnInit {
  @Input()
  public isWaiting: boolean;
  showForm = true;

  public contactUsForm: FormGroup;
  public hasFormBeenSubmitted = false;
  public messageDisplay: MessageDisplayModel = new MessageDisplayModel();

  constructor(private fb: FormBuilder, private messageDisplayService: MessageDisplayService, private messagesService: MessagesService) { }

  ngOnInit() {
    this.messageDisplayService.clearMessage();
    this.buildForm();
  }

  buildForm() {
    this.contactUsForm = this.fb.group({
      name: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  onFormSubmit() {
    this.hasFormBeenSubmitted = true;
    if (this.contactUsForm.valid) {
      this.messageDisplayService.clearMessage();
      this.messagesService.contactUs(this.contactUsForm.value)
        .then(() => {
          this.messageDisplay = this.messageDisplayService.createSuccessMessageDisplayWithGivenMessage(
            'Thank you. Your message has been sent.');
          this.showForm = false;
        }, () => {
          this.messageDisplay =
            this.messageDisplayService.createErrorMessageDisplayWithGivenMessage('There was  problem sending your message');
          this.showForm = true;
        });

      console.log('Form is valid');
    }
  }

  public shouldFormFieldShowAnError(field) {
    return checkForFormFieldErrors(field, this.hasFormBeenSubmitted);
  }
}
